module.exports = __webpack_public_path__ + "img/11.63f672ab.png";